import RenderPipeline from "../../../lib/services/render/renderpipeline";
import ShaderService from "../../../lib/services/shader/shader_service";
import ResourceService from "../../../lib/services/resource/resourceservice";
import {
  updateBlobUniforms,
  createBlobUniformBuffer,
  createBlobQuadVertexBuffer,
  createBlobRenderPipeline,
  createBlobBindGroupLayout,
  createBlobBindGroup,
} from "./blob_instance_types";
import { VideoDisplayInfo } from "./video_display_helper";
import ColorGpuSlot from "../../../compute/color_gpu_slot";

export default class ScanFeedbackPipeline extends RenderPipeline {
  label: string;
  shader_name: string;

  bind_group: GPUBindGroup | null = null;
  private layout: GPUBindGroupLayout | null = null;
  private quad_vb: GPUBuffer | null = null;
  private instance_buffer: GPUBuffer | null = null;
  private draw_args_buffer: GPUBuffer | null = null;
  private uniform_buffer: GPUBuffer | null = null;

  constructor(key: string, shader_name: string) {
    super(key + "_scan_feedback");
    this.label = key + "_scan_feedback";
    this.shader_name = shader_name;
  }

  async build(
    device: GPUDevice,
    format: GPUTextureFormat,
    shader_service: ShaderService,
    _resource_service: ResourceService
  ): Promise<void> {
    const shader = shader_service.get_render(this.shader_name);
    this.quad_vb = createBlobQuadVertexBuffer(device);
    this.layout = createBlobBindGroupLayout(device);
    this.uniform_buffer = createBlobUniformBuffer(device);
    this.bind_group = createBlobBindGroup(device, this.layout, this.uniform_buffer);
    this.pipeline = createBlobRenderPipeline(device, format, shader, this.layout);
  }

  prepare(device: GPUDevice, slot: ColorGpuSlot, info: VideoDisplayInfo): void {
    if (!this.uniform_buffer) return;
    updateBlobUniforms(device, this.uniform_buffer, info.dstW, info.dstH);
    this.instance_buffer = slot.packed_blobs_buffer;
    this.draw_args_buffer = slot.packed_count_buffer;
  }

  draw(pass: GPURenderPassEncoder): void {
    if (
      !this.pipeline ||
      !this.bind_group ||
      !this.quad_vb ||
      !this.instance_buffer ||
      !this.draw_args_buffer
    )
      return;
    pass.setPipeline(this.pipeline);
    pass.setBindGroup(0, this.bind_group);
    pass.setVertexBuffer(0, this.quad_vb);
    pass.setVertexBuffer(1, this.instance_buffer);
    pass.drawIndirect(this.draw_args_buffer, 0);
  }
}
